// ResetPassword.jsx
import React, { useState } from "react";
import SpinnerOverlay from "../components/spinnerOverlay/SpinnerOverlay"; // Adjust path as needed
import "./ResetPassword.css";
import api from "../utils/api";

const ResetPasswordPage = () => {
  const [identifier, setIdentifier] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateForm = () => {
    let tempErrors = {};
    if (!identifier.trim()) {
      setErrors({ identifier: "Email or phone is required" });
      return;
    }
    // if (!email.trim()) {
    //   tempErrors.email = "Email is required";
    // } else if (!/\S+@\S+\.\S+/.test(email)) {
    //   tempErrors.email = "Email is invalid";
    // }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        window.location.href = "/reset-confirm";
      }, 2000);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!identifier.trim()) {
      setErrors({ identifier: "Email or phone is required" });
      return;
    }

    setIsLoading(true);
    try {
      await api.post("/users/forgot-password", { identifier });
      setSuccess(true);
    } catch (err) {
      setErrors({ submit: err.response?.data?.message || "Failed to send reset link" });
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="reset-container">
        <img src="../images/tutors-logo.png" alt="Logo" className="reset-logo" />
        <div className="reset-form-container">
          <h1>Check Your Email/Phone</h1>
          <p>We sent a password reset link to {identifier}</p>
          <a href="/login">Back to Login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-container">
      {isLoading && <SpinnerOverlay />}
      {/* <div className="logo-container"> */}
        <img
          src="../images/tutors-logo.png"
          alt="Website Logo"
          className="reset-logo"
        />
      {/* </div> */}
      <div className="reset-form-container">
        <h1 className="reset-title">Reset your password</h1>
        <p className="reset-subtitle">
         Enter your email or phone number to receive a reset link
        </p>
        <form onSubmit={handleSubmit}>
          <div className="reset-form-group">
            <label>Email or Phone Number</label>
            <input
              type="text"
               placeholder="tutorslinks@gmail.com or +2348012345678"
             value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="input-field"
            />
            {/* {errors.email && <p className="error">{errors.email}</p>} */}
            {errors.identifier && <p className="error">{errors.identifier}</p>}
            {errors.submit && <p className="error">{errors.submit}</p>}
          </div>
          <button type="submit" className="create-account-btn">
            Send Reset Link <span className="arrow">→</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
